import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import "./Message.css";

class Message extends React.Component {
	render() {
		// Was the message sent by the current user. If so, add a css class
let myMessage = this.props.message.create_uid.id === this.props.activeUser.id;

		const fromMeClass =
		myMessage
				? "from-me"
				: "";

		return (
			<div className={`message ${fromMeClass} row`}>
				<div className={"message-header col-lg-12 col-md-12 col-sm-12 col-12 " + (!myMessage ? "row" : "")}>
					<div className="message-username">
						{this.props.message.create_uid.name}
					</div>
					<div className="message-date span-center-verticaly">
						{this.props.message.date.format("DD/MM/YYYY HH:mm")}
					</div>
				</div>
				<div
					className="message-body"
					dangerouslySetInnerHTML={{ __html: this.props.message.body }}
				></div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
	};
};

const mapDispatchToProps = () => {
	return {};
};

Message.propTypes = {
	message: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Message);
